<template>
  <div>
    <div data-cy="form-label" class="b-dialog__top-panel mb-4">
      <h2>{{$t('CONTENT.assets.asset_editing')}}</h2>
      <button class="b-btn b-btn_border_none" @click="closeEditAssetPopup">
        <dynamic-icon icon="close" />
      </button>
    </div>
    <form class="b-form b-dialog__form">
      <server-error :error="error" />
      <div class="mb-4">
        <CreateOrChooseAssetSmallWidget
          :availableAssetIds="availableAssetIds"
          :isEdit="true"
          @selectedAssetId="setSelectedAsset"
        />
      </div>
      <AssetComponentWithoutStore
        :contract="contract"
        :assetComponent="assetComponent"
        :unitsOfMeasure="getUnitOfMeasure"
        :validationErrors="validationErrors"
        ></AssetComponentWithoutStore>
      <div class="row mt-4">
        <div class="col-6 offset-6">
          <div
            class="b-form__container b-form__container_type_flex b-form__container_type_flex_end"
          >
            <button
              data-cy="save-button"
              class="b-btn b-btn_type_primary"
              type="submit"
              @click.prevent="onSubmit"
            >{{$t('CONTENT.save')}}</button>
            <button
              class="b-btn b-btn_type_empty m-2"
              @click.prevent="closeEditAssetPopup"
            >{{$t('CONTENT.cancel')}}</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import ExtensionOption from "../../../../../models/contract/ExtensionOption";
  import TerminationOption from "../../../../../models/contract/TerminationOption";
  import BuyoutOption from "../../../../../models/contract/BuyoutOption";
  import CreateOrChooseAssetSmallWidget from "../../../../widgets/CreateOrChooseAssetSmallWidget";
  import AssetComponent from "../../../../../plugins/assetComponent/models/AssetComponent";

  export default {
    props: {
      contract: {
        type: Object,
      },
      assetComponent: {
        type: Object,
      }
    },
    components: {
      CreateOrChooseAssetSmallWidget,
    },
    data() {
      return {
        error: null,
        formData: {},
        validationErrors: [],
        currentAssetId: null,
      };
    },
    // created() {
    //   this.init();
    // },
    computed: {
      ...mapGetters(["getUnitOfMeasure"]),
      ...mapGetters(['getAssets']),
      availableAssetIds() {
        return this.getAssets;
      }
    },
    methods: {
      // cancel() {
      //   // this.init();
      // },
      // init() {
      //   this.assetComponent = new AssetComponent.createNew();
      //   this.assetComponent.assetId = this.currentAssetId;
      // },
      async onSubmit(e) {
        e.preventDefault();

        if (!this.validate()) return;

        if(!this.assetComponent.buyout.isSure) {
          this.assetComponent.buyout = null;
        }
        if(!this.assetComponent.extension.isSure) {
          this.assetComponent.extension = null;
        }
        if(!this.assetComponent.termination.isSure) {
          this.assetComponent.termination = null;
        }

        this.$emit('addAssetComponent', this.assetComponent);

        // this.$eventBus.$emit('addAssetComponent', this.assetComponent);

        this.$emit("close");
        this.currentAssetId = null;

      },
      setSelectedAsset(assetIdInfoObject) {
        this.assetComponent.assetId = assetIdInfoObject.currentAssetId;
      },
      closeEditAssetPopup() {
        this.$emit("close");
      },
      validate() {
        this.validationErrors = [];
        let assetComponent = _.cloneDeep(this.assetComponent);
        if (!assetComponent.startDate) {
          this.validationErrors.push("startDate");
        }
        if (!assetComponent.endDate) {
          this.validationErrors.push("endDate");
        }
        if (!assetComponent.quantity) {
          this.validationErrors.push("quantity");
        }
        if (!assetComponent.unitOfMeasureCode) {
          this.validationErrors.push("unitOfMeasureCode");
        }

        return this.validationErrors.length <= 0;
      }
    }
  };
</script>
